import React            from 'react';
import EditDialogModel       from '../schedule/EditDialogModel';
import { Theme, makeStyles } from '../utility/styles';
import DefaultEditFormView   from './DefaultEditFormView';

const editPanelFormStyles = (_theme: Theme) => ({
  form: {
    overflowY: 'initial',
  },
  fields: {
    overflowY: 'initial',
  },
  fieldContainer: {
    width: '100%',
    margin: '0px 0px 15px 0px !important',
    '& > div': {
      display: 'flex',
    },
  },
});

export const useEditPanelFormStyles = makeStyles(editPanelFormStyles);
export default React.memo(({ editor, classes }: { editor: EditDialogModel, classes?: any }) => {
  const editPanelFormClasses = useEditPanelFormStyles({classes});
  return (
    <DefaultEditFormView editor={editor} classes={editPanelFormClasses} />
  );
});